module.exports = __webpack_public_path__ + "img/stone.db41a481.svg";